module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "value-chain"
  }, [(_vm.loading && !_vm.data) ? _c('div', {
    staticClass: "chain"
  }, [_c('div', {
    staticClass: "chain__title"
  }, [_vm._v("\n            Værdikæde\n            "), _c('div', {
    staticStyle: {
      "font-size": "16px",
      "display": "inline-block"
    }
  }, [_c('d-tooltip', {
    attrs: {
      "placement": "inline",
      "identifier": "index.valuechain"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('box-loading')], 1)]) : _vm._e(), _vm._v(" "), (_vm.data) ? _c('div', {
    staticClass: "chain"
  }, [_c('div', {
    staticClass: "chain__title"
  }, [_vm._v("\n            Værdikæde\n            "), _c('div', {
    staticStyle: {
      "font-size": "16px",
      "display": "inline-block"
    }
  }, [_c('d-tooltip', {
    attrs: {
      "placement": "inline",
      "identifier": "index.valuechain"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "links"
  }, [_c('div', {
    staticClass: "link"
  }, [_c('div', {
    staticClass: "name"
  }, [_c('div', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fad fa-file-alt fa-fw"
  }), _vm._v("\n                        " + _vm._s(_vm.data.offer.count) + "\n                    ")]), _vm._v("\n                    tilbud, der afventer afgørelse\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "coverage"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("Potentielt DB")]), _vm._v("\n                    " + _vm._s(_vm._f("currency")(_vm.data.offer.expected_coverage)) + "\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "revenue"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("Potentiel omsætning")]), _vm._v("\n                    " + _vm._s(_vm._f("currency")(_vm.data.offer.expected_revenue)) + "\n                ")]), _vm._v(" "), (_vm.$auth.user().company.api_provider.slug === 'minuba') ? _c('div', {
    staticClass: "budget"
  }, [_c('span', {
    staticClass: "budget-bar-wrapper"
  }, [_c('span', {
    staticClass: "budget-bar-inner",
    style: ('width:' + (_vm.data.offer.count > 0 ? ((_vm.data.offer.has_budget / _vm.data.offer.count) * 100) : 0) + '%;')
  })]), _vm._v(" "), _c('span', {
    staticClass: "small mt-1"
  }, [_vm._v(_vm._s(_vm.data.offer.has_budget) + " / " + _vm._s(_vm.data.offer.count) + " opgaver har budget")])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "link"
  }, [_c('div', {
    staticClass: "name"
  }, [_c('div', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fad fa-inbox-in fa-fw"
  }), _vm._v("\n                        " + _vm._s(_vm.data.open.count) + "\n                    ")]), _vm._v("\n                    opgaver, der ikke er påbegyndt\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "coverage"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("Forventet DB")]), _vm._v("\n                    " + _vm._s(_vm._f("currency")(_vm.data.open.expected_coverage)) + "\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "revenue"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("Forventet omsætning")]), _vm._v("\n                    " + _vm._s(_vm._f("currency")(_vm.data.open.expected_revenue)) + "\n                ")]), _vm._v(" "), (_vm.$auth.user().company.api_provider.slug === 'minuba') ? _c('div', {
    staticClass: "budget"
  }, [_c('span', {
    staticClass: "budget-bar-wrapper"
  }, [_c('span', {
    staticClass: "budget-bar-inner",
    style: ('width:' + (_vm.data.open.count > 0 ? ((_vm.data.open.has_budget / _vm.data.open.count) * 100) : 0) + '%;')
  })]), _vm._v(" "), _c('span', {
    staticClass: "small mt-1"
  }, [_vm._v(_vm._s(_vm.data.open.has_budget) + " / " + _vm._s(_vm.data.open.count) + " opgaver har budget")])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "link"
  }, [_c('div', {
    staticClass: "name"
  }, [_c('div', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fad fa-clock fa-fw"
  }), _vm._v("\n                        " + _vm._s(_vm.data.ongoing.count) + "\n                    ")]), _vm._v("\n                    igangværende opgaver,\n                    "), _c('br'), _vm._v("\n                    der arbejdes på\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "coverage"
  }, [_c('span', [_c('span', {
    staticClass: "small"
  }, [_vm._v("Værdi, salgspris")]), _vm._v("\n                        " + _vm._s(_vm._f("currency")(_vm.data.ongoing.value_with_avg_cp)) + "\n                    ")])]), _vm._v(" "), _vm._m(0), _vm._v(" "), (_vm.$auth.user().company.api_provider.slug === 'minuba') ? _c('div', {
    staticClass: "budget"
  }, [_c('span', {
    staticClass: "budget-bar-wrapper"
  }, [_c('span', {
    staticClass: "budget-bar-inner",
    style: ('width:' + (_vm.data.ongoing.count > 0 ? ((_vm.data.ongoing.has_budget / _vm.data.ongoing.count) * 100) : 0) + '%;')
  })]), _vm._v(" "), _c('span', {
    staticClass: "small mt-1"
  }, [_vm._v(_vm._s(_vm.data.ongoing.has_budget) + " / " + _vm._s(_vm.data.ongoing.count) + " opgaver har budget")])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "link"
  }, [_c('div', {
    staticClass: "name"
  }, [_c('div', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fad fa-check-circle fa-fw"
  }), _vm._v("\n                        " + _vm._s(_vm.data.unbilled.count) + "\n                    ")]), _vm._v("\n                    afsluttede opgaver,\n                    "), _c('br'), _vm._v("\n                    der ikke er fakturerede\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "coverage"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("Værdi, salgspris")]), _vm._v("\n                    " + _vm._s(_vm._f("currency")(_vm.data.unbilled.value_with_avg_cp)) + "\n                ")]), _vm._v(" "), _vm._m(1), _vm._v(" "), (_vm.$auth.user().company.api_provider.slug === 'minuba') ? _c('div', {
    staticClass: "budget"
  }, [_c('span', {
    staticClass: "budget-bar-wrapper"
  }, [_c('span', {
    staticClass: "budget-bar-inner",
    style: ('width:' + (_vm.data.unbilled.count > 0 ? ((_vm.data.unbilled.has_budget / _vm.data.unbilled.count) * 100) : 0) + '%;')
  })]), _vm._v(" "), _c('span', {
    staticClass: "small mt-1"
  }, [_vm._v(_vm._s(_vm.data.unbilled.has_budget) + " / " + _vm._s(_vm.data.unbilled.count) + " opgaver har budget")])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "link"
  }, [_c('div', {
    staticClass: "name"
  }, [_c('div', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fad fa-envelope-open-dollar fa-fw"
  }), _vm._v("\n                        " + _vm._s(_vm.data.unpaid_invoices.count) + "\n                    ")]), _vm._v("\n                    fakturaer, der endnu ikke er betalt\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "coverage"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("Forventet DB")]), _vm._v("\n                    " + _vm._s(_vm._f("currency")(_vm.data.unpaid_invoices.expected_coverage)) + "\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "revenue"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("Forventet omsætning")]), _vm._v("\n                    " + _vm._s(_vm._f("currency")(_vm.data.unpaid_invoices.expected_revenue)) + "\n                ")])]), _vm._v(" "), _c('div', {
    staticClass: "link"
  }, [_c('div', {
    staticClass: "name"
  }, [_c('div', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fad fa-calendar-exclamation fa-fw"
  }), _vm._v("\n                        " + _vm._s(_vm.data.overdue_invoices.count) + "\n                    ")]), _vm._v("\n                    fakturaer med overskredet betaling\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "coverage"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("Forventet DB")]), _vm._v("\n                    " + _vm._s(_vm._f("currency")(_vm.data.overdue_invoices.expected_coverage)) + "\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "revenue"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("Forventet omsætning")]), _vm._v("\n                    " + _vm._s(_vm._f("currency")(_vm.data.overdue_invoices.expected_revenue)) + "\n                ")])])])]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "revenue",
    staticStyle: {
      "opacity": "0"
    }
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("Placeholder")]), _vm._v("\n                    Placeholder\n                ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "revenue",
    staticStyle: {
      "opacity": "0"
    }
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("Placeholder")]), _vm._v("\n                    Placeholder\n                ")])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-55170067"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/index/components/valueChain.vue
// module id = 867
// module chunks = 0